import { LandingHero, LandingHeroProps } from '../../../../components/_external-pages/landing';

const props: LandingHeroProps = {
  title: 'Unimos personas por un mercado',
  titlePrimary: ' más justo.',
  image: '/static/about/hero.webp',
  overlay: '/static/overlay3.svg'
};

export const AboutHero = () => {
  return <LandingHero {...props} />;
};
